import { render } from "./RiBookmarkOff.vue?vue&type=template&id=8add87c8"
import script from "./RiBookmarkOff.vue?vue&type=script&lang=js"
export * from "./RiBookmarkOff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiBookmarkOff.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8add87c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8add87c8', __exports__)) {
    api.reload('8add87c8', __exports__)
  }
  
  module.hot.accept("./RiBookmarkOff.vue?vue&type=template&id=8add87c8", () => {
    api.rerender('8add87c8', render)
  })

}


export default __exports__